/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteInvitationMutationResponse,
  DeleteInvitationPathParams,
  DeleteInvitation400,
} from '../types/DeleteInvitation'

function getDeleteInvitationUrl({
  id,
}: {
  id: DeleteInvitationPathParams['id']
}) {
  const res = { method: 'DELETE', url: `/api/v1/invitations/${id}/` as const }
  return res
}

/**
 * @description Delete an invitation by ID.
 * @summary Delete an invitation
 * {@link /api/v1/invitations/:id/}
 */
export async function deleteInvitation(
  { id }: { id: DeleteInvitationPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteInvitationMutationResponse,
    ResponseErrorConfig<DeleteInvitation400>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteInvitationUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
